import * as React from 'react';
import type { SVGProps } from 'react';
const SvgHorizontalBarsStacked100 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={297}
    height={252}
    fill="none"
    {...props}
  >
    <path
      fill="#EEEEF3"
      fillRule="evenodd"
      d="M93.51 36.597V79.14h62.826V36.597z"
      clipRule="evenodd"
    />
    <path
      fill="#E2E2EB"
      fillRule="evenodd"
      d="M44.878 36.597V79.15H93.51V36.597z"
      clipRule="evenodd"
    />
    <path
      fill="#F6F6F9"
      fillRule="evenodd"
      d="M150.858 36.597V79.14h86.568c6.715 0 12.158-5.443 12.158-12.158V48.755c0-6.715-5.443-12.158-12.158-12.158zM177.783 103.472v42.542h59.643c6.715 0 12.158-5.443 12.158-12.158V115.63c0-6.715-5.443-12.158-12.158-12.158z"
      clipRule="evenodd"
    />
    <path
      fill="#EEEEF3"
      fillRule="evenodd"
      d="M123.933 103.472v42.542h53.85v-42.542z"
      clipRule="evenodd"
    />
    <path
      fill="#E2E2EB"
      fillRule="evenodd"
      d="M44.874 103.472v42.553h85.105v-42.553z"
      clipRule="evenodd"
    />
    <path
      fill="#EEEEF3"
      fillRule="evenodd"
      d="M114.957 170.347v42.542h71.801v-42.542z"
      clipRule="evenodd"
    />
    <path
      fill="#E2E2EB"
      fillRule="evenodd"
      d="M44.875 170.347V212.9h72.948v-42.553z"
      clipRule="evenodd"
    />
    <path
      fill="#F6F6F9"
      fillRule="evenodd"
      d="M186.758 170.347v42.542h50.668c6.715 0 12.158-5.443 12.158-12.158v-18.226c0-6.715-5.443-12.158-12.158-12.158z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgHorizontalBarsStacked100;
